import script from "./html-text-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./html-text-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./html-text-setting-ly.vue?vue&type=style&index=0&id=7c6b4730&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c6b4730"]])

export default __exports__